import { VehicleType } from 'core/types/vehicleType';

export const SET_VEHICLE_TYPES = 'SET_VEHICLE_TYPES';

export class SetVehicleTypes {
  readonly type = SET_VEHICLE_TYPES;
  readonly payload: VehicleType[];

  constructor(statuses: VehicleType[]) {
    this.payload = statuses;
  }
}

export type Action = SetVehicleTypes;
